import { Route, Routes } from "react-router";
import AIVideoList from "./AIVideoList";
import AIVideoEditor from "./AIVideoEditor";

function AIVideoRoutes() {
  return (
    <Routes>
      <Route path="" element={<AIVideoList />} />
      <Route path=":id" element={<AIVideoEditor />} />
    </Routes>
  );
}

export default AIVideoRoutes;
